import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import {
  Button,
  ButtonVariant,
} from "../../../../../core-ui/components/Button/Button";
import { Text } from "../../../../../core-ui/components/Text/Text";
import {
  TextColor,
  TextStyleVariant,
} from "../../../../../core-ui/components/Text/TextUtils";
import {
  GenerateBookingCardContainer,
  GenerateBookingCheckboxContainer,
  GenerateBookingHeaderContainer,
  GenerateBookingHeaderTextContainer,
} from "../../../../../elements/GenerateBookingCard/GenerateBookingCard.styles";

export interface CreateReleaseCardProps {
  selected: boolean;
  onClick: () => void;
  isDesktop: boolean;
  title: string;
  description: string;
}

export const CreateReleaseCard = ({
  selected,
  onClick,
  isDesktop,
  title,
  description,
}: CreateReleaseCardProps) => {
  return (
    <Button
      variant={ButtonVariant.UNSTYLED}
      onClick={onClick}
      // fullWidth={!isDesktop}
    >
      <GenerateBookingCardContainer $isDesktop={isDesktop} $selected={selected}>
        <GenerateBookingHeaderContainer>
          <GenerateBookingHeaderTextContainer
            className={classNames({ selected })}
          >
            <Text
              style={{ fontSize: "1.375rem" }}
              variant={TextStyleVariant.S3}
            >
              {title}
            </Text>
          </GenerateBookingHeaderTextContainer>
          <GenerateBookingCheckboxContainer $selected={selected}>
            <FontAwesomeIcon icon={faCheck} />
          </GenerateBookingCheckboxContainer>
        </GenerateBookingHeaderContainer>
        <Text bold color={TextColor.SECONDARY} sx={{ textAlign: "left" }}>
          {description}
        </Text>
      </GenerateBookingCardContainer>
    </Button>
  );
};
